import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { apiGetVideoList, IVideoList } from "../api/controllers/get-video-list";
import GlobalHelmetProvider from "../components/global/GlobalHelmetProvider";
import VideoThumb from "../components/VideoThumb";

const Videos = () => {
  const [list, setList] = useState<IVideoList>();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    apiGetVideoList()
      .then((r) => setList(r))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const videos = list?.data || [];

  return (
    <main className="page videos-page">
      <GlobalHelmetProvider title="Videos" description="Every Conditioning documentary, with sources and credits." />
      <header className="page-head">
        <h1>Videos</h1>
        {videos.length > 0 && <span className="page-count">{videos.length}</span>}
      </header>
      <div className="video-grid">
        {videos.map((v) => (
          <Link to={`/videos/${v.attributes.video_slug}`} className="video-card" key={v.id}>
            <div className="video-card-img">
              <VideoThumb src={v.attributes.thumb_url?.data?.attributes?.formats?.small?.url} videoUrl={v.attributes.video_id} />
            </div>
            <h2>{v.attributes.title}</h2>
          </Link>
        ))}
      </div>
      {!loading && videos.length === 0 && <p className="page-empty">No videos yet.</p>}
    </main>
  );
};

export default Videos;
